<template>
  <div class="upstream">
    <steps @clickStep="changeSteps" :index="upstreamIndex" :steps="functionSteps"></steps>
    <div v-if="upstreamIndex===1" class="form-body">
      <div class="form-group">
        <label>命令字设置</label>
        <div class="d-flex align-items-start">
          <div>
            <div class="form-inline">
              <input v-model="rule.packetRule.key.pt[0]" type="text" class="form-control mr-2" placeholder="">
              <span class="mr-2">--</span>
              <input v-model="rule.packetRule.key.pt[1]" type="text" class="form-control mr-4" placeholder="">
            </div>
            <small class="text-muted">
              坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <data-arr text="内容" v-model="rule.packetRule.key.ct"></data-arr>

          </div>
        </div>
      </div>
    </div>

    <div v-if="upstreamIndex===2" class="form-body">
      <div class="form-group">
        <label>长度</label>
        <div class="d-flex align-items-start ">
          <div class="mr-4">
            <div class="form-inline">
              <text-input v-model="rule.packetRule.len.pt[0]"></text-input>
              <span class="mr-2">--</span>
              <text-input v-model="rule.packetRule.len.pt[1]"></text-input>
            </div>
            <small class="form-text">
              长度坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <select class="form-control" v-model="rule.packetRule.len.ayl">
              <option value="" selected>解析方式</option>
            </select>
            <small class="form-text">
              长度解析方式
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.len.ctStPt"></text-input>
            <small class="form-text">
              固定内容起始坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.len.ctCtLen"></text-input>
            <small class="form-text">
              固定内容长度
            </small>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>包头</label>
        <div class="d-flex align-items-start ">
          <div class="form-group mr-4">
            <!-- <text-input v-model="rule.packetRule.head.ct"></text-input> -->
           <data-arr v-model="rule.packetRule.head.ct"></data-arr>


          </div>
        </div>
      </div>
      <div class="form-group">
        <label>包尾</label>
        <div class="d-flex align-items-start ">
          <div class="form-group mr-4">
            <!-- <text-input v-model="rule.packetRule.tail"></text-input> -->
           <data-arr v-model="rule.packetRule.tail"></data-arr>


          </div>
        </div>
      </div>
      <div class="form-group">
        <label>校验码</label>
        <div class="d-flex align-items-start ">
          <div class="mr-4">
            <div class="form-inline">
              <text-input v-model="rule.packetRule.ck.pt[0]"></text-input>
              <span class="mr-2">--</span>
              <text-input v-model="rule.packetRule.ck.pt[1]"></text-input>
            </div>
            <small class="form-text">
              校验码坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <select class="form-control" v-model="rule.packetRule.ck.ayl">
              <option value="" selected>解析方式</option>
            </select>
            <small class="form-text">
              校验码解析方式
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.ck.ctStPt"></text-input>
            <small class="form-text">
              固定内容起始坐标
            </small>
          </div>
          <div class="form-group mr-4">
            <text-input v-model="rule.packetRule.ck.ctCtLen"></text-input>
            <small class="form-text">
              固定内容长度
            </small>
          </div>
        </div>
      </div>
    </div>
    <div v-if="upstreamIndex===3" class="form-body">
      <template v-if="type==='XT'||type==='WS'">
        <div class="form-group">
          <label>上行内容</label>
          <div class="d-flex align-items-start">
            <div class="form-group mr-4">
              <data-arr v-model="rule.ct"></data-arr>
            </div>
          </div>
        </div>
        <div  class="form-group">
          <label>设备ID</label>
          <div class="d-flex align-items-start">
            <div class="form-group mr-4">
              <div class="form-inline">
                <text-input v-model="rule.devId.pt[0]"></text-input>
                <span class="mr-2">--</span>
                <text-input v-model="rule.devId.pt[1]"></text-input>
              </div>
              <small class="text-text">
                设备ID坐标
              </small>
            </div>
            <div class="form-group mr-4">
              <select v-model="rule.devId.ayl" class="form-control" >
                <option value="" selected>解析方式</option>
              </select>
              <small class="form-text">
                设备ID解析方式
              </small>
            </div>
          </div>

        </div>
      </template>
      <template v-else>
        <div>
          <div class="form-group">
            <label>上行超时时间</label>
            <div class="d-flex align-items-start">
              <div class="form-group mr-4">
                <input v-model="rule.timeout" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>数据返回类型设置</label>
            <div class="d-flex align-items-start">
              <div class="form-group mr-4">
                <select @change="changeDataType" v-model="rule.dataType" class="form-control">
                  <option :value="0">布尔值</option>
                  <option :value="1">字典</option>
                  <option :value="2">数组</option>
                  <option :value="3">组合字典</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group data-type">
            <label>解析规则设置</label>
            <!--布尔值解析-->
            <template v-if="rule.dataType===0">
              <div class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <input v-model="aylOpt[0].ayl" type="text" class="form-control">
                  <small class="form-text">
                    解析方式
                  </small>
                </div>
                <div class="mr-4">
                  <div class="form-inline">
                    <input v-model="aylOpt[0].pt[0]" class="form-control mr-2">
                    <span class="mr-2">--</span>
                    <input v-model="aylOpt[0].pt[1]" class="form-control">
                  </div>
                  <small class="form-text">
                    解析内容坐标
                  </small>
                </div>

              </div>
              <div class="d-flex align-items-start mb-2">
                <div class="mr-4">
                  <input v-model="aylOpt[0].ayl" type="text" class="form-control">
                  <small class="form-text">
                    成功值
                  </small>
                </div>
              </div>
              <div class="d-flex align-items-start mb-2">
                <div class="mr-4">
                  <input v-model="aylOpt[0].ayl" type="text" class="form-control">
                  <small class="form-text">
                    失败值
                  </small>
                </div>
              </div>

            </template>
            <!--字典类型解析-->
            <template v-if="rule.dataType===1">
              <div v-for="item in aylOpt[1]" class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <input v-model="item.name" type="text" class="form-control">
                  <small class="form-text">
                    变量名
                  </small>
                </div>
                <div class="mr-4">
                  <div class="form-inline">
                    <input v-model="item.pt[0]" class="form-control mr-2">
                    <span class="mr-2">--</span>
                    <input v-model="item.pt[1]" class="form-control">
                  </div>
                  <small class="form-text">
                    解析内容坐标
                  </small>
                </div>
                <div class="mr-4">
                  <select v-model="item.ayl" class="form-control">
                    <option v-for="(value,key) in aylNames" :title="value.dtl" :value="key">{{value.itd}}</option>
                  </select>
                  <small class="form-text">
                    解析方式
                  </small>
                </div>
              </div>
              <button @click="addItemData" class="btn" >+</button>
            </template>
            <!--LIST类型解析-->
            <template v-if="rule.dataType===2">
              <div class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <div class="form-inline">
                    <input v-model="aylOpt[2].pt[0]" class="form-control mr-2">
                    <span class="mr-2">--</span>
                    <input v-model="aylOpt[2].pt[1]" class="form-control">
                  </div>
                  <small class="form-text">
                    解析内容坐标
                  </small>
                </div>
                <div class="mr-4">
                  <select v-model="aylOpt[2].ayl" class="form-control">
                    <option v-for="(value,key) in aylNames" :title="value.dtl" :value="key">{{value.itd}}</option>
                  </select>
                  <small class="form-text">
                    解析方式
                  </small>
                </div>
              </div>
              <div class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <input v-model="aylOpt[2].fixedLen" type="text" class="form-control">
                  <small class="form-text">
                    固定内容长度
                  </small>
                </div>
                <div class="mr-4">
                  <dataArr text="分隔符" v-model="aylOpt[2].separator"></dataArr>
                </div>
              </div>
            </template>
            <!--组合字典类型解析-->
            <template v-if="rule.dataType===3">
              <p class="sub-title">+分隔规则</p>
              <div class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <input v-model.number="aylOpt[3].fixedLen" type="text" class="form-control">
                  <small class="form-text">
                    固定内容长度
                  </small>
                </div>
                <div class="mr-4">
                  <dataArr text="分隔符" v-model="aylOpt[3].separator"></dataArr>
                </div>
              </div>
              <p class="sub-title">+key的解析规则</p>
              <div class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <div class="form-inline">
                    <input v-model="aylOpt[3].id.rtlPt[0]" class="form-control mr-2">
                    <span class="mr-2">--</span>
                    <input v-model="aylOpt[3].id.rtlPt[1]" class="form-control">
                  </div>
                  <small class="form-text">
                    子数据包第一位为起点相对坐标
                  </small>
                </div>
                <div class="mr-4">
                  <select v-model="aylOpt[3].id.ayl" class="form-control">
                    <option v-for="(value,key) in aylNames" :title="value.dtl" :value="key">{{value.itd}}</option>
                  </select>
                  <small class="form-text">
                    解析方式
                  </small>
                </div>
              </div>
              <p class="sub-title">+value的解析规则</p>
              <div v-for="item in aylOpt[3].cld" class="d-flex align-items-start mb-4">
                <div class="mr-4">
                  <input v-model="item.name" type="text" class="form-control">
                  <small class="form-text">
                    名称
                  </small>
                </div>
                <div class="mr-4">
                  <div class="form-inline">
                    <input v-model="item.rtlPt[0]" class="form-control mr-2">
                    <span class="mr-2">--</span>
                    <input v-model="item.rtlPt[1]" class="form-control">
                  </div>
                  <small class="form-text">
                    解析内容坐标
                  </small>
                </div>
                <div class="mr-4">
                  <select v-model="item.ayl" class="form-control">
                    <option v-for="(value,key) in aylNames" :title="value.dtl" :value="key">{{value.itd}}</option>
                  </select>
                  <small class="form-text">
                    解析方式
                  </small>
                </div>
              </div>
              <button class="btn" @click="addItemData" >+</button>
            </template>
          </div>
        </div>

      </template>

    </div>
  </div>
</template>

<script>
  import steps from './steps'
  import textInput from './text-input'
  import dataArr from './data-arr'

  export default {
    name: "upstream",
    components: {
      steps,
      textInput,
      dataArr
    },
    watch:{
      rule:{
        handler(newValue, oldValue) {
          console.log(newValue)
          this.$emit('input',newValue);
        },
        deep: true
      }

    },
    computed:{
      rule(){
        console.log('computed')
        return this.value
      }
    },
    props: {
      type:{type:String},
      value: {
        type: Object,
        default() {
          return {
            packetRule: {
              timeout: '',//连接超时时间
              len: {
                pt: [0, 0], ayl: '', ctStPt: '', ctCtLen: '',//# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
              },
              count: '',//数据包总长度(心跳握手特有)
              'head': {'ct': [2, 3]},//包头{ 包头内容, 包头坐标 }
              'tail': [255],//包尾
              'ck': {'pt': [], 'ayl': '', 'ctStPt': 3, 'ctCtLen': 3}, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
              'key': {'ct': [], pt: []}, // 功能key{ 功能key内容, 功能key坐标 }
            },
            'ct': [255],// 握手包上行内容
            'devId': { 'pt': [], 'ayl': '' } //握手包devId{ devId坐标，devId解析方式 }
          }
        }
      },

    },
    data() {
      return {
        a: '',
        upstreamIndex: 1,
        functionSteps: [
          {
            title: "命令字设置"
          },
          {
            title: "基础属性"
          },
          {
            title: "其他属性"
          },
        ],
        aylOpt:[
          {
            pt:[0,0],
            ayl:0,
            blex:{}
          },[{
            pt:[0,0],
            ayl:0,
            name:''
          }],{
            pt:[0,0],
            ayl:0,
            fixedLen:0,
            separator:[]
          },{
            cld:[{
              rtlPt:[0,0],
              ayl:0,
              name:''
            }],
            id:{
              rtlPt:[0,0],
              ayl:0
            },
            fixedlen:0,
            separator:[]
          }

        ],
        aylNames:{
          5001:{'itd':'uchar转int64大序', 'dtl':'unsigned char数组转换为int64_t类型,长度8,高位在前低位在后'},
          5002:{'itd':'uchar转int64小序', 'dtl':'unsigned char数组转换为int64_t类型,长度8,低位在前高位在后'},
        }

      }
    },
    methods: {
      changeDataType(){
        this.rule.ayl=this.aylOpt[this.rule.dataType]
      },
      changeSteps(index) {
        this.upstreamIndex = index + 1;
      },
      addItemData(){
        let type =this.rule.dataType,
           ayl = this.aylOpt[this.rule.dataType];
        switch(type){
          case 1:
           ayl.push({
             pt:[0,0],
             ayl:0,
             name:''
           });
            break;
          case 3:
            ayl.cld.push({
              rtlPt:[0,0],
              ayl:0,
              name:''
            });
            break
        }

      }
    }

  }
</script>

<style lang="scss"  scoped>
  .text-input {
    width: 100px;
  }

  .form-body {
    padding: 3rem 0;
  }
  .data-type{
    .form-control{
      width: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/subSystem/upstream.vue